import React from 'react';
import { Box } from '@mui/material';

export default function ColorIndicator({
  color,
  isHorizontal = false,
}: {
  color: string;
  isHorizontal?: boolean;
}) {
  return (
    <Box
      sx={{
        bgcolor: color,
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: isHorizontal ? 0 : 10,
        borderTopRightRadius: isHorizontal ? 10 : 0,
        borderBottomRightRadius: 0,
        width: isHorizontal ? 1 : 10,
        height: isHorizontal ? 10 : 1,
      }}
    ></Box>
  );
}
